import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ThemeService, ColorTheme } from './theme.service';

@Injectable({
	providedIn: 'root',
})
export class PreferencesService {
	#theme = inject(ThemeService);

	get theme$(): Observable<ColorTheme> {
		return this.#theme.theme$;
	}

	setTheme(isDarkMode: boolean) {
		if (isDarkMode) {
			this.#theme.setDarkMode();
		} else {
			this.#theme.setLightMode();
		}
	}
}
